import React, { FC } from 'react';

import Logo from 'components/Logo';
import Button from 'components/Button';

import NavigationDropdown from './dropdown';
import NavigationItem from './item';

import {
    NavProfile,
    NavMoreButton,
    NavMenu,
    LogoStyled,
    MainCTA,
    SlotLeft,
    SlotRight,
    Wrapper,
    NavSecondary,
    NavCTA,
    Navigation as NavigationWrapper,
} from './styled';

export type NavigationProps = {
    /** Displays Yousician logo */
    showLogo?: boolean;

    /** Properties for the logo tag */
    logoProps?: any;

    /** Current logged in user */
    user: {
        avatar: string;
        menu?: React.ReactNode;
    } | null;

    /** Shows the user widget (login/current user) */
    showUser?: boolean;

    /** Additional properties for the login button */
    loginButtonProps?: any;

    /** Displays a CTA on the left area */
    cta?: any;

    loginLabel?: string;

    menu?: React.ReactNode;

    profileLabel?: string;

    onToggleMobileMenu?: () => void;
};

const Navigation: FC<
    NavigationProps & React.HTMLAttributes<HTMLDivElement>
> = ({
    cta,
    showLogo,
    logoProps,
    showUser,
    menu,
    user,
    loginButtonProps,
    profileLabel,
    loginLabel,
    onToggleMobileMenu,
    ...rest
}) => {
    return (
        <Wrapper id="navigation" {...rest}>
            <NavigationWrapper>
                <SlotLeft>
                    {showLogo && (
                        <LogoStyled {...logoProps} data-type="nav_logo">
                            <Logo className="main" />
                            <Logo className="icon" icon />
                        </LogoStyled>
                    )}

                    {cta && (
                        <MainCTA>
                            <Button
                                size="medium"
                                theme="primary"
                                {...cta.props}
                            >
                                {cta.label}
                            </Button>
                        </MainCTA>
                    )}
                </SlotLeft>

                <SlotRight>
                    <NavMenu>
                        {menu && menu}
                        {user && showUser ? (
                            <NavSecondary>
                                <NavigationDropdown
                                    label={profileLabel ? profileLabel : ''}
                                    itemChildren={
                                        <NavProfile
                                            src={user.avatar}
                                            alt="Your avatar"
                                        />
                                    }
                                >
                                    {user.menu}
                                </NavigationDropdown>
                            </NavSecondary>
                        ) : showUser ? (
                            <NavCTA>
                                <Button
                                    {...loginButtonProps}
                                    size="medium"
                                    theme="white"
                                >
                                    {loginLabel}
                                </Button>
                            </NavCTA>
                        ) : null}
                    </NavMenu>

                    {menu && (
                        <NavMoreButton
                            onClick={() =>
                                onToggleMobileMenu && onToggleMobileMenu()
                            }
                        />
                    )}
                </SlotRight>
            </NavigationWrapper>
        </Wrapper>
    );
};

export default Navigation;

export { NavigationDropdown, NavigationItem };
